import type { AriaAttributes } from "react";

import type { OptionType } from "ui/select/select.types";

export const getOptionLabelString = (option: OptionType | string): string => {
  if (typeof option === "string") return option;
  if (typeof option.label === "string") return option.label;
  if (typeof option.shortValueToDisplay === "string") return option.shortValueToDisplay;
  return String(option.value ?? "");
};

export const isSameOption = (a: OptionType, b: OptionType): boolean =>
  String(a?.value) === String(b?.value);

/** Splits `aria-*` off a props object, so they can go to the element they describe. */
export const splitAriaProps = <Props extends object>(
  props: Props,
): { ariaProps: AriaAttributes; otherProps: Props } => {
  const ariaProps: Record<string, unknown> = {};
  const otherProps: Record<string, unknown> = {};

  Object.entries(props).forEach(([key, value]) => {
    (key.startsWith("aria-") ? ariaProps : otherProps)[key] = value;
  });

  return { ariaProps: ariaProps as AriaAttributes, otherProps: otherProps as Props };
};

/** Space-separated ids, as `aria-describedby` takes them; `undefined` when there are none. */
export const joinIds = (...ids: (string | undefined)[]) =>
  ids.filter(Boolean).join(" ") || undefined;
